import { Decision } from "./Decision";
import {
  ResourceItem,
  IncompleteResourceItem,
  SimpleResourceItem,
  getItemReferencePostData,
} from "./ResourceItem";
import { Resource } from "../resource";
import { RevisionActions } from "../revision";

function parseDecisionData(data: any) {
  return {
    ...data,
    acceptedAt: data.acceptedAt ? new Date(data.acceptedAt) : null,
    rejectedAt: data.rejectedAt ? new Date(data.rejectedAt) : null,
  };
}

export class RevisionItem extends ResourceItem {
  constructor(data?: any) {
    super(data);

    if (data) {
      this.startingDecision = data.startingDecision
        ? parseDecisionData(data.startingDecision)
        : null;
      this.endingDecision = data.endingDecision
        ? parseDecisionData(data.endingDecision)
        : null;

      this.name = data.name;
      this.activeId = data.activeId;
      this.isDraft = data.isDraft;
      this.isActive = data.isActive;
      this.target = data.target;
      this.drafts = data.drafts;
    }
  }

  name: string = "";
  activeId?: number;
  isDraft?: Boolean;
  isActive?: Boolean;
  target?: IncompleteResourceItem;
  startingDecision?: Decision | null;
  endingDecision?: Decision | null;

  drafts?: IncompleteResourceItem[];

  toString(): string {
    return this.id ? this.id.toString() : "Nowy rekord";
  }

  getPostData(): any {
    return {
      name: this.name,
      target: this.target ? { activeId: this.target.activeId } : null,
    };
  }
}

export interface RevisionMetadata<TDetail extends RevisionItem = any> {
  resource: Resource<RevisionActions<TDetail, any>>;
  constructor: new (data: any) => TDetail;
}

export interface SimpleRevisionItem extends SimpleResourceItem {
  activeId: number;
}
